document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', function () {
  const menuButton = document.querySelector('[data-menu-toggle]');
  const menu = document.querySelector('[data-menu]');

  if (menuButton && menu) {
    const closeMenu = function () {
      menu.classList.remove('open');
      menuButton.setAttribute('aria-expanded', 'false');
    };

    menuButton.addEventListener('click', function () {
      const isOpen = menu.classList.toggle('open');
      menuButton.setAttribute('aria-expanded', String(isOpen));
    });

    menu.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', closeMenu);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeMenu();
    });
  }

  document.querySelectorAll('[data-hero-slider]').forEach(function (slider) {
    const slides = Array.from(slider.querySelectorAll('[data-hero-slide]'));
    const dots = Array.from(slider.querySelectorAll('[data-hero-dot]'));
    const previousButton = slider.querySelector('[data-hero-previous]');
    const nextButton = slider.querySelector('[data-hero-next]');
    const status = slider.querySelector('[data-hero-status]');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let currentIndex = 0;
    let rotationTimer = null;
    let touchStartX = null;

    if (slides.length < 2) return;

    const showSlide = function (requestedIndex, announce) {
      const nextIndex = (requestedIndex + slides.length) % slides.length;

      slides.forEach(function (slide, index) {
        const isActive = index === nextIndex;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', String(!isActive));
      });

      dots.forEach(function (dot, index) {
        const isActive = index === nextIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-current', String(isActive));
      });

      currentIndex = nextIndex;
      if (announce && status) status.textContent = 'Image ' + (currentIndex + 1) + ' of ' + slides.length;
    };

    const stopRotation = function () {
      if (rotationTimer) window.clearInterval(rotationTimer);
      rotationTimer = null;
    };

    const startRotation = function () {
      stopRotation();
      if (reducedMotion || document.hidden) return;
      rotationTimer = window.setInterval(function () {
        showSlide(currentIndex + 1, false);
      }, 6000);
    };

    const selectSlide = function (index) {
      showSlide(index, true);
      startRotation();
    };

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        selectSlide(Number(dot.getAttribute('data-hero-index')));
      });
    });

    if (previousButton) previousButton.addEventListener('click', function () { selectSlide(currentIndex - 1); });
    if (nextButton) nextButton.addEventListener('click', function () { selectSlide(currentIndex + 1); });

    slider.addEventListener('mouseenter', stopRotation);
    slider.addEventListener('mouseleave', startRotation);
    slider.addEventListener('focusin', stopRotation);
    slider.addEventListener('focusout', startRotation);

    slider.addEventListener('touchstart', function (event) {
      stopRotation();
      if (event.touches.length === 1) touchStartX = event.touches[0].clientX;
    }, { passive: true });

    slider.addEventListener('touchend', function (event) {
      if (touchStartX === null || event.changedTouches.length !== 1) {
        startRotation();
        return;
      }
      const distance = event.changedTouches[0].clientX - touchStartX;
      touchStartX = null;
      if (Math.abs(distance) >= 45) showSlide(distance > 0 ? currentIndex - 1 : currentIndex + 1, true);
      startRotation();
    }, { passive: true });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stopRotation();
      else startRotation();
    });

    startRotation();
  });

  const filters = document.querySelectorAll('[data-filter]');
  const cards = document.querySelectorAll('[data-product-grid] [data-category]');

  filters.forEach(function (button) {
    button.addEventListener('click', function () {
      const category = button.getAttribute('data-filter');
      filters.forEach(function (item) {
        const isActive = item === button;
        item.classList.toggle('active', isActive);
        item.setAttribute('aria-pressed', String(isActive));
      });
      cards.forEach(function (card) {
        const categories = (card.getAttribute('data-category') || '').split(/\s+/).filter(Boolean);
        card.hidden = category !== 'all' && !categories.includes(category);
      });
    });
  });

  document.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
    const viewport = gallery.querySelector('[data-gallery-viewport]');
    const slides = Array.from(gallery.querySelectorAll('[data-gallery-slide]'));
    const thumbnails = Array.from(gallery.querySelectorAll('[data-gallery-thumbnail]'));
    const previousButton = gallery.querySelector('[data-gallery-previous]');
    const nextButton = gallery.querySelector('[data-gallery-next]');
    const counter = gallery.querySelector('[data-gallery-current]');
    const variantSelect = document.querySelector('[data-product-variant-select]');
    const productPrice = document.querySelector('[data-product-price]');
    let currentIndex = 0;
    let touchStartX = null;

    if (!viewport || slides.length === 0) return;

    const pauseMedia = function (slide) {
      slide.querySelectorAll('video').forEach(function (video) {
        video.pause();
      });

      slide.querySelectorAll('iframe').forEach(function (frame) {
        if (!frame.contentWindow) return;
        frame.contentWindow.postMessage(JSON.stringify({ event: 'command', func: 'pauseVideo', args: '' }), '*');
        frame.contentWindow.postMessage(JSON.stringify({ method: 'pause' }), '*');
      });
    };

    const showSlide = function (requestedIndex) {
      const nextIndex = (requestedIndex + slides.length) % slides.length;

      slides.forEach(function (slide, index) {
        const isActive = index === nextIndex;
        if (!isActive) pauseMedia(slide);
        slide.hidden = !isActive;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', String(!isActive));
      });

      thumbnails.forEach(function (thumbnail, index) {
        const isActive = index === nextIndex;
        thumbnail.classList.toggle('is-active', isActive);
        thumbnail.setAttribute('aria-current', String(isActive));
        thumbnail.tabIndex = isActive ? 0 : -1;
      });

      currentIndex = nextIndex;
      if (counter) counter.textContent = String(currentIndex + 1);

      if (thumbnails[currentIndex]) {
        thumbnails[currentIndex].scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'nearest',
          inline: 'center'
        });
      }
    };

    thumbnails.forEach(function (thumbnail) {
      thumbnail.addEventListener('click', function () {
        showSlide(Number(thumbnail.getAttribute('data-gallery-index')));
      });
    });

    if (previousButton) previousButton.addEventListener('click', function () { showSlide(currentIndex - 1); });
    if (nextButton) nextButton.addEventListener('click', function () { showSlide(currentIndex + 1); });

    viewport.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        showSlide(currentIndex - 1);
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        showSlide(currentIndex + 1);
      } else if (event.key === 'Home') {
        event.preventDefault();
        showSlide(0);
      } else if (event.key === 'End') {
        event.preventDefault();
        showSlide(slides.length - 1);
      }
    });

    viewport.addEventListener('touchstart', function (event) {
      if (event.touches.length === 1) touchStartX = event.touches[0].clientX;
    }, { passive: true });

    viewport.addEventListener('touchend', function (event) {
      if (touchStartX === null || event.changedTouches.length !== 1) return;
      const distance = event.changedTouches[0].clientX - touchStartX;
      touchStartX = null;
      if (Math.abs(distance) < 45) return;
      showSlide(distance > 0 ? currentIndex - 1 : currentIndex + 1);
    }, { passive: true });

    if (variantSelect) {
      variantSelect.addEventListener('change', function () {
        const selectedOption = variantSelect.options[variantSelect.selectedIndex];
        const mediaId = selectedOption && selectedOption.getAttribute('data-media-id');
        const price = selectedOption && selectedOption.getAttribute('data-price');
        if (productPrice && price) productPrice.textContent = price;
        if (!mediaId) return;
        const mediaIndex = slides.findIndex(function (slide) {
          return slide.getAttribute('data-media-id') === mediaId;
        });
        if (mediaIndex >= 0) showSlide(mediaIndex);
      });
    }
  });
});
